export const servizioClientiCta = () => {
  window.location.href = 'https://www.illumia.it/assistenza-clienti/contatti-servizio-clienti/';
};
